import React from 'react'
// import { Input } from 'antd'
import './Description.scss'
import TextEditor from '../TextEditor/TextEditor'
const Description = ({ t, setDescription, description = '' }) => {
  // const onDescriptionChange = e => {
  //   setDescription(e.target.value)
  // }

  return (
    <div className="decription">
      <div className="decription__content">
        <div className="ant-row ant-form-item">
          <div className="description-input">
            <div className="description-input-title">
              {t('v3:podcast_description')}
            </div>
            <TextEditor value={description} onChange={setDescription} />
            {/* <Input.TextArea
              value={description}
              placeholder={t('v3:podcast_description')}
              onChange={onDescriptionChange}
              rows={3}
            /> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Description
